import RelatedProductsList from './RelatedProductsList';

export default RelatedProductsList;
